import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MONTHS, YearSummaryConsolidation} from '../../../shared/ec-economics';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-gse-delete',
    templateUrl: './gse-delete.component.html',
    styleUrls: ['./gse-delete.component.scss']
})
export class GseDeleteComponent implements OnInit, OnDestroy {
    private destroyed = new Subject<void>();
    @Input() activeMonths: YearSummaryConsolidation[] = [];
    @Output() yearAndMonth: EventEmitter<{ year: number, month: number }> = new EventEmitter<{ year: number, month: number }>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
    readonly form: FormGroup;
    yearAndMonths: { [year: number]: { month: number, consolidated: boolean }[] } = {};

    readonly Object = Object;
    readonly MONTHS = MONTHS;

    constructor(private readonly fb: FormBuilder) {
        this.form = this.fb.group({
            year: this.fb.control(null, [Validators.required]),
            month: this.fb.control(null, [Validators.required])
        });
    }

    ngOnInit(): void {
        this.yearAndMonths = this.activeMonths.reduce((acc, cm) => ((acc[cm.year] ??= []).push({month: cm.month, consolidated: cm.consolidated}), acc), {});
        this.form.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => {
                if (this.form.valid) {
                    this.yearAndMonth.emit({year: this.form.controls.year.value, month: this.form.controls.month.value});
                }
                this.valid.next(this.form.valid);
            });

    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

    onYearChange() {
        this.form.controls.month.reset();
    }

    get year(): number {
        return this.form.controls.year.value;
    }

}
